import angular from 'angular'

type StateParams = {
  token?: string
  email?: string
}

export class ResetPasswordInAppController {
  static $inject = ['$stateParams']

  token: string
  email: string

  constructor($stateParams: StateParams) {
    this.token = $stateParams.token ?? ''
    this.email = $stateParams.email ?? ''
  }
}

angular.module('app').controller('ResetPasswordInAppController', ResetPasswordInAppController)
